import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Tooltip} from '@mui/material';
import Button from '../../common/components/Button/Button';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import _Modal from '../../common/components/Modal/v2/Modal';
import apiServices from './api.services';

// El secret solo se conoce en el momento de generarlo (el backend guarda un
// hash); al recargar la página se muestra únicamente el clientId.
const HIDDEN_SECRET = '••••••••••••••••••••';

const Api = () => {
    const [credentials, setCredentials] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        apiServices.getCredentials()
            .then((data) => {
                if (data.response) setCredentials({clientId: data.response.clientId, clientSecret: null});
            })
            .catch(() => toast.error('No se pudieron obtener las credenciales'));
    }, []);

    const handleGenerate = () => {
        setLoading(true);
        setShowModal(false);
        apiServices.regenerateCredentials()
            .then((data) => {
                setCredentials(data.response);
                toast.success('Credenciales generadas');
            })
            .catch(() => toast.error('No se pudieron generar las credenciales'))
            .finally(() => setLoading(false));
    };

    const handleRegenerateClick = () => {
        setShowModal(true);
    };

    const copyToClipboard = (label, value) => {
        navigator.clipboard.writeText(value)
            .then(() => toast.success(`${label} copiado`))
            .catch(() => toast.error('No se pudo copiar'));
    };

    return (
        <div className={'page-content-container'}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <p className={'h3 v2-c-text-title'}>API</p>
                <Button size={'small'} onClick={() => history.push('/documentacion')}>Documentación</Button>
            </div>
            <div className={'page-table-container'} style={{padding: '24px'}}>
                <p className={'body-1 c-text-base'}>
                    Generá un Client ID y un Client Secret para integrar tus sistemas con la API.
                </p>
                {!credentials ?
                    <div style={{marginTop: '24px'}}>
                        <Button size={'medium'} disabled={loading} onClick={handleGenerate}>
                            {loading ? 'Generando...' : 'Generar credenciales'}
                        </Button>
                    </div> :
                    <div style={{marginTop: '24px', maxWidth: '640px', display: 'flex', flexDirection: 'column', gap: '16px'}}>
                        <div style={{display: 'flex', alignItems: 'flex-end', gap: '8px'}}>
                            <div style={{flex: 1}}>
                                <CustomInput
                                    label="Client ID"
                                    value={credentials.clientId}
                                    onChange={() => {}}
                                    disabled={true}
                                    type={'text'}
                                />
                            </div>
                            <Button size={'small'}
                                    onClick={() => copyToClipboard('Client ID', credentials.clientId)}>
                                Copiar
                            </Button>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-end', gap: '8px'}}>
                            <div style={{flex: 1}}>
                                <CustomInput
                                    label="Client Secret"
                                    value={credentials.clientSecret || HIDDEN_SECRET}
                                    onChange={() => {}}
                                    disabled={true}
                                    type={'text'}
                                />
                            </div>
                            {credentials.clientSecret &&
                                <Button size={'small'}
                                        onClick={() => copyToClipboard('Client Secret', credentials.clientSecret)}>
                                    Copiar
                                </Button>
                            }
                        </div>
                        <p className={'body-3 c-text-subtitle'}>
                            {credentials.clientSecret ?
                                'Guardá el Client Secret en un lugar seguro: no vas a poder volver a verlo.' :
                                'El Client Secret solo se muestra al generar las credenciales. Si lo perdiste, regenerá.'}
                        </p>
                        <div>
                            <Tooltip title={'Genera credenciales nuevas y las anteriores dejan de funcionar'}>
                                <div style={{display: 'inline-block'}}>
                                    <Button size={'small'} disabled={loading} onClick={handleRegenerateClick}>
                                        {loading ? 'Generando...' : 'Regenerar'}
                                    </Button>
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                }
                {showModal && (
                    <_Modal
                        showModal={showModal}
                        handleClose={() => setShowModal(false)}
                        handleClick={handleGenerate}
                        modalTitle={'Regenerar credenciales'}
                        modalButtonText={'Regenerar'}
                        modalText={'¿Seguro que desea regenerar las credenciales? Las actuales dejarán de funcionar.'}
                    />
                )}
            </div>
        </div>
    );
};

export default Api;
